import {
    transition,
    trigger,
    query,
    style,
    animate,
    group,
    animateChild
} from '@angular/animations';
export const slideInAnimation =
    trigger('routeAnimations', [

        // forward animation
        transition('mainMobile => accountSection', [
            style({ position: 'relative' }),
            query(':enter, :leave', [
                style({
                  position: 'absolute',
                  top: 0,
                  right: 0,
                  width: '100%'
                })
            ]),
            query(':enter', [style({ right: '-100%', opacity: 0 })], { optional: true }),
            query(':leave', animateChild(), { optional: true }),
            group([
                query(':leave',[
                    animate('0.4s ease-in'),
                    style({ right: '-100%', opacity: 0 })
                ], { optional: true }),
                query(':enter', [
                    animate('0.4s ease-out',
                    style({ right: '0%', opacity: 1 }))
                ], { optional: true }),
            ]),
            query(':enter', animateChild(), { optional: true }),
        ]),

        //back animation
        transition('accountSection => mainMobile', [
            style({ position: 'relative' }),
            query(':enter, :leave', [
                style({
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%'
                })
            ]),
            query(':enter', [style({ left: '-100%', opacity: 0 })]),
            query(':leave', animateChild()),
            group([
                query(':leave',[
                    animate('0.4s ease-in'),
                    style({ left: '100%', opacity: 0 })
                ], { optional: true }),
                query(':enter', [
                    animate('0.4s ease-out',
                    style({ left: '0%', opacity: 1 }))
                ], { optional: true })
            ]),
            query(':enter', animateChild())
        ]),
    ]);